import { render, staticRenderFns } from "./VAdvertiseImage.vue?vue&type=template&id=891583f6&scoped=true&"
import script from "./VAdvertiseImage.vue?vue&type=script&lang=js&"
export * from "./VAdvertiseImage.vue?vue&type=script&lang=js&"
import style0 from "./VAdvertiseImage.vue?vue&type=style&index=0&id=891583f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891583f6",
  null
  
)

export default component.exports